import './index.scss';
import TypoGraphy from '@/typography';
import { TestimonialProps } from '@/interfaces';
import { ImageWithFallback } from '@/utilitycomponents/Imagewithfallback';
import useViewType from '@/utils/Hooks/useViewType';
const TestimonialsCard = ({
  image,
  name,
  designation,
  desc,
  company,
  isModal
}: TestimonialProps) => {
  const isMobile = useViewType();
  const desctext = isModal ? desc : desc?.substring(0, 130) + '...';
  return <div className="testimonial_card_wrapper" style={{
    width: isModal ? "100% !important" : isMobile ? "233px" : "432px",
    cursor: isModal ? "auto" : "pointer"
  }} suppressHydrationWarning={true} data-sentry-component="TestimonialsCard" data-sentry-source-file="index.tsx">
      <div className="over_flow_wrapper">
        <div className="top_section">
          <div className="image_wrapper">
            <ImageWithFallback imageUrl={image.replace('gs-strapi-prod-s3.s3.ap-south-1.amazonaws.com', 'strapi-gs-items.gumlet.io') + "?q=25"} altTagText='learner' altImage={''} width={40} height={40} data-sentry-element="ImageWithFallback" data-sentry-source-file="index.tsx" />
          </div>
          <div className="text_wrapper">
            <TypoGraphy text={name} variant={isMobile ? 'Mobile/Body 2/M | 14 | 120' : 'Desktop/Body 2/M | 14 |120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            {designation && company && <TypoGraphy text={`${designation}, ${company}`} variant={'Desktop/Body 2/R | 14 |120'} />}
          </div>
        </div>
        <div className="description">
          <TypoGraphy text={desctext} title={!isModal ? desc : ''} tagName={isModal ? 'p' : 'a'} href='#' variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 2'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
        </div>
      </div>
    </div>;
};
export default TestimonialsCard;